module.exports = __webpack_public_path__ + "img/goods5_6.f777bc8a.jpg";